import { StopActivityProps } from '../../../models/stopActivity.model';
import { EXECUTIONSTATUS } from '../../../utils/constants';
import { StartTripModel } from '../../../models/home/StartTrip.model';
import { dayjs } from '../../../utils/Date/DateUtil';
export class LoadStopModel {
    public startTripModel = new StartTripModel();
  /*
   * is all stop completed or not
   * @shipment - shipment for the trip
   */
  public isAllStopCompleted(shipment: any): boolean {
    let allStopCompleted = false;
    if (shipment?.loadStop) {
      let loadStop: any[] = shipment.loadStop || [];
      loadStop = loadStop.slice().sort((load1: any, load2: any) => {
        if (load1.sequenceNo && load2.sequenceNo) {
          return load1.sequenceNo - load2.sequenceNo;
        }
        if (load1.stopSequence && load2.stopSequence) {
          return load1.stopSequence - load2.stopSequence;
        }
        return 0;
      });
     
      if (loadStop.length > 0) {
        allStopCompleted = !!loadStop[loadStop.length - 1].actualDepartureDateTime && !StartTripModel.getInvalidTrailer;
      } else {
        allStopCompleted = true;
      }
    }
    return allStopCompleted;
  }

  public isTripCompleted(shipment: any): boolean {
    return (
      (shipment && (shipment.executionStatus === EXECUTIONSTATUS.COMPLETED || shipment.executionStatus === EXECUTIONSTATUS.DELIVERED)) ||
      false
    );
  }
 public getMomentDate(e:Date){
  return e === null ? dayjs().format().toString() : dayjs(e).format().toString();
 }
  /*
   * get the ETA value
   * @loadStop - loadStop of the shipment
   */
  public getETA(loadStop: any): string {
    // estimatedArrivalDateTime -- planned ETA
    const {
      estimatedArrivalDateTime,
      actualETADateTime,
      appointmentEarlyDateTime,
      plannedEtaDateTime
    } = loadStop;
    let etaTime = '';
    if (actualETADateTime) {
      etaTime = actualETADateTime;
    } else if (plannedEtaDateTime) {
      etaTime = plannedEtaDateTime;
    } else if (appointmentEarlyDateTime) {
      etaTime = appointmentEarlyDateTime;
    } else if (estimatedArrivalDateTime) {
      etaTime = estimatedArrivalDateTime;
    }
    if (etaTime) {
      etaTime = this.startTripModel.getTimeForIOS(etaTime);
    }
    return etaTime || '';
  }
  /*
   * get the PlannedArrivalTime value without ETA
   * @loadStop - loadStop of the shipment
   */

  public getPlannedArrivalTime(loadStop: any): string {
    // plannedArrivalDateTime -- time without ETA
    const {
      plannedArrivalDateTime
    } = loadStop;
    let plannedArrivalTime = '';
    if (plannedArrivalDateTime) {
      plannedArrivalTime = plannedArrivalDateTime;
    }
    if (plannedArrivalTime) {
      plannedArrivalTime = this.startTripModel.getTimeForIOS(plannedArrivalTime);
    }
    return plannedArrivalTime || '';
  }
  /*
   * get the arrival value
   * @loadStop - loadStop of the shipment
   */
  public getArrival(loadStop: any, isNextStop: boolean): string {
    let { actualArrivalDateTime } = loadStop;

    if (actualArrivalDateTime) {
      actualArrivalDateTime = this.startTripModel.getTimeForIOS(actualArrivalDateTime);
    }
    return actualArrivalDateTime;
  }

  /*
   * get the arrival lable name
   * @loadStop - loadStop of the shipment
   */
  public getArrivalLabelName(loadStop: any, isNextStop: boolean): string {
    const { actualArrivalDateTime } = loadStop;

    return actualArrivalDateTime && !isNextStop ? 'Arrived' : 'Arrival';
  }

  /*
   * get the departure value
   * @loadStop - loadStop of the shipment
   */
  public getDeparture(loadStop: any, isNextStop: boolean): string {
    let { actualDepartureDateTime } = loadStop;
    if (actualDepartureDateTime) {
      actualDepartureDateTime = this.startTripModel.getTimeForIOS(actualDepartureDateTime);
    }
    return actualDepartureDateTime;
  }

  /*
   * get the departure lable name
   * @loadStop - loadStop of the shipment
   */
  public getDepartureLabelName(loadStop: any): string {
    const { actualDepartureDateTime } = loadStop;

    return actualDepartureDateTime ? 'Departed' : 'Departure';
  }

  /*
   * check whether ETA is readonly or not
   * @loadStop - loadStop of the shipment
   */
  public isETAReadonly(loadStop: any): boolean {
    const { actualArrivalDateTime, actualDepartureDateTime } = loadStop;
    let readonly = false;
    if (actualArrivalDateTime || actualDepartureDateTime) {
      readonly = true;
    }

    return readonly;
  }

  /*
   * check whether Arrival is readonly or not
   * @loadStop - loadStop of the shipment
   */
  public isArrivalReadonly(loadStop: any): boolean {
    const { actualDepartureDateTime, actualArrivalDateTime } = loadStop;
    let readonly = false;
    if (actualDepartureDateTime || actualArrivalDateTime) {
      readonly = true;
    }

    return readonly;
  }

  /*
   * check whether Departure is readonly or not
   * @loadStop - loadStop of the shipment
   */
  public isDepartureReadonly(loadStop: any, arrivalVal: string): boolean {
    const { actualDepartureDateTime, actualArrivalDateTime } = loadStop;
    let readonly = false;
    if (!!!actualArrivalDateTime) {
      readonly = true;
    }
    if (arrivalVal) {
      readonly = false;
    }
    if (actualDepartureDateTime) {
      readonly = true;
    }

    return readonly;
  }

  /*
   * Check whether stop activities are missing or not
   * @activity - stop activities
   */
  public areStopActivitiesMissing(load: any): boolean {
    const activity: StopActivityProps[] = (load?.stopActivity) || [];
    const newActivity: StopActivityProps[] = [];
    activity.forEach((item: StopActivityProps) => {
      if ((item.tmsActivity || '').toUpperCase().trim() !== 'bobtail') {
        newActivity.push(item);
      }
    });
    return newActivity.length === 0 || false;
  }
}